import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const MedicalCondition = ({ onMedicalConditionSelected }) => {
  const [selectedMedicalCondition, setSelectedMedicalCondition] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.medicalcondition) {
        const medicalConditionObject = firstResult.medicalcondition;
        if (medicalConditionObject.trim() !== "") {
          setVariations(medicalConditionObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleMedicalConditionClick = (medicalcondition) => {
    setSelectedMedicalCondition(medicalcondition);
    onMedicalConditionSelected(medicalcondition);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Medical Condition:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedMedicalCondition === variation ? "selected" : ""}`}
            onClick={() => handleMedicalConditionClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default MedicalCondition;
